import notify from "devextreme/ui/notify";
import { Parser } from "json2csv";

export const copyCSVToClipboard = (dataSource) => {
  const fields = Object.keys(dataSource[0]);
  const opts = { fields };

  try {
    const parser = new Parser(opts);
    const csv = parser.parse(dataSource);

    navigator.clipboard.writeText(csv);

    notify("Data to csv format copied to clipboard");
  } catch (err) {
    console.error(err);
  }
};

export const currenciesToSymbols = {
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  USD: "$",
  NOK: "kr",
  DKK: "kr",
  SEK: "kr",
  SGD: "S$",
  AED: "د.إ",
};

export const downloadPdf = (url, fileName) => {
  const tempLink = document.createElement("a");
  tempLink.href = url;
  tempLink.setAttribute("download", fileName);
  tempLink.click();
};

export const getLocalStorageItem = (name) =>
  JSON.parse(localStorage.getItem(name));

export const setLocalStorageItem = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};
